export const SET_TERMS_MODAL = 'SET_TERMS_MODAL'
export const SET_TERMS_TIMESTAMP = 'SET_TERMS_TIMESTAMP'

  const state = {
    termsModal: false,
    termsTimestamp: ''
  }
  const getters = {
    termsModal: state => state.termsModal,
    termsTimestamp: state => state.termsTimestamp
  }
  const actions = {
    checkTerms( {commit} ) {
      // ** TODO: check user's time stamped Term Accepted date against Current Terms Date
      // if older then re-present the Terms and Conditions acceptance from **
      // console.log("TCL: checkTerms -> termsModal")
      commit('SET_TERMS_MODAL', true)
      return
    },
    setTermsModal ( { commit }, status ) {
      // console.log("TCL: setTermsModal -> status", status)
      commit ('SET_TERMS_MODAL', status)
    },
    setTimestamp( {commit} ) {
      const time = new Date()
      commit('SET_TERMS_TIMESTAMP', time)
    }
  }
  const mutations = {
    [SET_TERMS_MODAL](state, status) {
      state.termsModal = status
    },
    [SET_TERMS_TIMESTAMP](state, time) {
      state.termsTimestamp = time
    }
  }

  export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/term.js